module.exports = __webpack_public_path__ + "img/page-under-construction.d3d1d71e.svg";